import React from 'react'
import { Spacer } from '../ListItem'
import { Label } from './'
import { RESOURCE_GRID } from '../../../../lib/constants'

const ResourceHeader = ({ data }) => {
	return (
		<>
			<div>
				<Label>Resource</Label>
				<Label>Info</Label>
				<Label>Topics</Label>
			</div>

			<style jsx>{`
				div {
					width: 100%;

					padding-bottom: 0.625rem;
					border-bottom: 2px solid black;
					display: grid;
					grid-template-columns: ${RESOURCE_GRID};
				}

				@media (pointer: coarse) and (max-width: 1025px) {
					div {
						display: none;
					}
				}
			`}</style>
		</>
	)
}

export default ResourceHeader
